import { render, staticRenderFns } from "./patientReport.vue?vue&type=template&id=5f3020d2&scoped=true&"
import script from "./patientReport.vue?vue&type=script&lang=js&"
export * from "./patientReport.vue?vue&type=script&lang=js&"
import style0 from "./patientReport.vue?vue&type=style&index=0&id=5f3020d2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3020d2",
  null
  
)

component.options.__file = "patientReport.vue"
export default component.exports